import { render, staticRenderFns } from "./buyMoreTir.vue?vue&type=template&id=27c37448"
import script from "./buyMoreTir.vue?vue&type=script&lang=js"
export * from "./buyMoreTir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports